// src/pages/Main/labs.js

import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { LabCard } from "pages/Main/frontCards";
import { LABS } from "pages/Main/frontContent";
import { BandHead, PageHead, SectionTitle } from "pages/Main/frontPage";
import Title from "context/title";

// A section with an `all` band ends with a link to the organization that holds its whole list.
const SECTIONS = [
  ["onnx", "ONNX Models", "fp-g3", "Strongly versioned storage for neural network models, with the computational "
    + "graph browsable in place. Six of the onnx-models collection's fifteen, each card showing the model's README "
    + "visual.", {
    text: "Text, audio, image, video, 3D vision, biology and time series, and three classics from the ONNX Model "
      + "Zoo. Each opens on its browsable graph and a README with a quick start.",
    to: "/onnx-models",
    more: "Open onnx-models",
  }],
  ["graphs", "Knowledge Graphs", "fp-g3", "Linked-data repositories with assisted querying and traversal controls, "
    + "embeddable anywhere with the graph-view widget."],
  ["datasets", "NLP Datasets", "fp-g5", "SuperGLUE benchmark datasets, shown in their own shape rather than as rows "
    + "of JSON.", {
    text: "The eight tasks and the two diagnostics, AX-b and AX-g, each a blob of its own in the superglue "
      + "organization.",
    to: "/superglue",
    more: "Open superglue",
  }],
];

export default class Labs extends Component {
  componentDidMount() {
    Title.set("Labs");
  }

  render() {
    return (
      <>
        <PageHead
          eyebrow="Labs"
          title="Models, graphs and datasets"
          text={"At its core, BlobHub is typed, versioned storage behind one API. A blob's type says what it holds, "
            + "and every type gets the same treatment: revisions, access control and the API. So the core supports any "
            + "kind of data a type can describe. These ONNX models, knowledge graphs and NLP datasets are types of "
            + "their own, each opened in a view made for its kind of data."} />
        <Container className="fp-page-stack">
          {SECTIONS.map(([key, title, grid, text, all]) => (
            <section key={key} className="fp-labs-section">
              <SectionTitle title={title} text={text} />
              <div className={`fp-grid ${grid}`}>
                {LABS[key].map((item) => <LabCard key={item.key} item={item} />)}
              </div>
              {all && <div className="fp-labs-all"><BandHead {...all} /></div>}
            </section>
          ))}
        </Container>
      </>
    );
  }
}
